import { Component, input, OnInit, inject } from '@angular/core';
import { IonIcon } from "@ionic/angular/standalone";
import { Router } from '@angular/router';

import { addIcons } from 'ionicons';
import { chevronForwardOutline } from 'ionicons/icons';
import { Membership } from '@net3-multiplatform-client/libs';



@Component({
  selector: 'community-selector',
  imports: [IonIcon],
  templateUrl: './community-selector.html',
  styleUrl: './community-selector.scss',
})
export class CommunitySelector implements OnInit {
  router = inject(Router);

  community = input<Membership>();

  constructor() {
    addIcons({ chevronForwardOutline });
  }

  ngOnInit(): void {
    //console.log("List Comunities Selector");
  }

  goComunnitie() {
    const c = this.community();
    if (c) {
      this.router.navigate(['/communities', c.schema_id]);
    }
  }
}
